'use client';

import React from 'react';
import { MarketingPageComponentProps } from '@services/launches/fetchLaunchMarketingContent';
import { Box, Stack } from '@mui/material';
import ParallaxText from '@components/ParallaxText';
import ReactHtmlParser from '@libs/reactHtmlParser';
import CommonContainer from '@components/CommonContainer';
import CustomImage from '@components/CustomImage';
import cn from './style.module.scss';

export default function WimbledonBridgeInformation(
  props: MarketingPageComponentProps
) {
  const content =
    props.locale.section?.wimbledonBridgeWhyWimbledonElement || [];

  return (
    <Stack component="section" className={cn.wimbledonBridgeInformation}>
      <Box className={cn.wimbledonInformationInner}>
        <CommonContainer
          maxWidth={{ xs: '100%', md: '1360px', lg: '1360px' }}
          flexGrow={1}
        >
          <Box className={cn.wimbledonInformationBody}>
            <Box className={cn.wimbledonInformationData}>
              {content.map((item: any, index: number) => (
                <Box className={cn.wimbledonInformationElement}>
                  <Box className={cn.wimbledonInformationIcon}>
                    <CustomImage
                      src={item.WhyWimbledonIcon || ''}
                      alt={'Wimbledon Feature Image'}
                      width={768}
                      height={768}
                    />
                  </Box>
                  <Box className={cn.wimbledonInformationText}>
                    <ParallaxText
                      key={index}
                      variant="p"
                      animationType="zoomIn"
                      animationDuration={500}
                    >
                      {ReactHtmlParser(item.WhyWimbledonDescription)}
                    </ParallaxText>
                  </Box>
                </Box>
              ))}
            </Box>
            <Box className={cn.wimbledonInformationHeading}>
              <ParallaxText
                variant="h2"
                animationType="zoomIn"
                animationDuration={500}
              >
                {ReactHtmlParser(
                  props.locale.section?.wimbledonBridgeWhyWimbledonHeading || ''
                )}
              </ParallaxText>
            </Box>
          </Box>
        </CommonContainer>
      </Box>
    </Stack>
  );
}
